import React from 'react';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices,SelectInput,
    Create, SimpleForm, TextInput, DateInput,ReferenceInput,
    BooleanInput, NumberInput, ImageInput, ImageField,AutocompleteInput,FormDataConsumer
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';

export const CityCreate = props => (
    <Create {...props} title="City" 
    >
        <SimpleForm redirect="list" 
        variant="outlined">
            <TextInput validate={required()} source="code" label="City Code" fullWidth={true} />
            <TextInput validate={required()} source="name" label="City Name" fullWidth={true} />
            <ReferenceInput variant="outlined" label="State" source="stateId"
                                                    reference="states" perPage={500}
                                                   
                                                    validate={required()} 
                                                    sort={{ field: 'name', order: 'ASC' }}
                                                    shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}
                                                    fullWidth={true} > 
                                                    <AutocompleteInput validate={required()} optionText="name" variant="outlined"
                                                     shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}  fullWidth={true}  
                                                     />
                                                </ReferenceInput>
                                                <FormDataConsumer fullWidth>
                {({ formData, ...rest }) =>
                    formData.stateId ? (
                        <ReferenceInput
                            label="District"
                            source="districtId"
                            reference="districts"
                            perPage={500}
                            validate={required()}
                            sort={{ field: 'name', order: 'ASC' }}
                            filter={{ stateId: formData.stateId }}
                            fullWidth
                            {...rest}
                        >
                            <AutocompleteInput optionText="name" fullWidth />
                        </ReferenceInput>
                    ) : null
                }
            </FormDataConsumer>
            <BooleanInput initialValue={true} source="isActive" />
        </SimpleForm>
    </Create>
);